const errorTypes = [
  { key: 'Please, enter valid credentials', translate: 'Please, enter valid credentials' },
  { key: 'invalid or existing email', translate: 'invalid or existing email' },
  { key: 'invalid or existing phone', translate: 'invalid or existing phone' },
  {
    key: 'cinemahive_app_user_email_key',
    translate: 'Invalid or existing email',
  },
  {
    key: 'cinemahive_app_user_phone_key',
    translate: 'Invalid or existing phone',
  },
];

export default errorTypes;
